import type { CreativeRow } from './api';
import type { CREATIVE_SCORE_COMPONENT_ACCENT } from './presentation';

export type CreativeScore = NonNullable<CreativeRow['creativeScore']>;

export type CreativeScoreComponentName = keyof typeof CREATIVE_SCORE_COMPONENT_ACCENT;

export type CreativeScoreComponent = NonNullable<
  CreativeScore['components'][CreativeScoreComponentName]
>;

export type ScoreTier = 'low' | 'medium' | 'high';

export const CREATIVE_SCORE_COMPONENT_ORDER: CreativeScoreComponentName[] = [
  'hook',
  'engagement',
  'watch',
  'leadingKpi',
  'elements',
];

export function creativeScoreComponentLabel(
  leadingKpiLabel: string,
): Record<CreativeScoreComponentName, string> {
  return {
    hook: 'Hook',
    engagement: 'Engagement',
    watch: 'Watch',
    leadingKpi: leadingKpiLabel,
    elements: 'Elements',
  };
}

export function scoreTier(score: number): ScoreTier {
  if (score <= 33) return 'low';
  if (score <= 66) return 'medium';
  return 'high';
}

export function orderedScoreComponents(
  components: CreativeScore['components'],
): Array<[CreativeScoreComponentName, CreativeScoreComponent]> {
  return CREATIVE_SCORE_COMPONENT_ORDER.filter((name) => components[name] !== undefined).map(
    (name) => [name, components[name] as CreativeScoreComponent],
  );
}
